const snackbarConstantsEn = {
  snackbarErrorMsg: 'Something Went Wrong',
  snackbarSuccessMsg: 'Saved Successfully',
  snackbarSuccessDeletedMsg: 'Deleted successfully',
  snackbarResendCodeSuccessMsg: 'Verification code was resent successfully',
  noDataToExport: 'No data to export',
  DataExportSuccess: 'Data exported successfully',
  inventoryManagementErrorSnackBar: 'An error occurred while loading data, please try again later',
};

export default snackbarConstantsEn;
